<template>
  <div :class="{ 'animation-mask': ifResourceOptions }">
    <el-form :inline="true" label-width="140px">
      <el-form-item :label="`选择动画时间类型：`" style="width: 95%;">
        <el-radio v-model="sonAnimationData.type" label="1"
          >选择时间范围</el-radio
        >
        <el-radio v-model="sonAnimationData.type" label="2"
          >设置总时间</el-radio
        >
      </el-form-item>
      <el-form-item
        v-if="sonAnimationData.type == '1'"
        :label="`请选择时间范围：`"
      >
        <el-date-picker
          v-model="sonAnimationData.selectTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-if="sonAnimationData.type == '2'"
        :label="`请选择总时长：`"
      >
        <el-time-picker
          v-model="sonAnimationData.totalTime"
          :default-value="new Date('1995-02-08 00:00:00')"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59',
          }"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="任意时间点"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="`每一帧的单位：`">
        <el-select v-model="sonAnimationData.company" placeholder="请选择">
          <el-option
            label="秒"
            value="second"
            :disabled="sonAnimationData.type == '1'"
          ></el-option>
          <el-option
            label="分"
            value="minute"
            :disabled="sonAnimationData.type == '1'"
          ></el-option>
          <el-option
            label="时"
            value="hour"
            :disabled="sonAnimationData.type == '1'"
          ></el-option>
          <el-option
            label="天"
            value="day"
            :disabled="sonAnimationData.type == '2'"
          ></el-option>
          <el-option
            label="月"
            value="month"
            :disabled="sonAnimationData.type == '2'"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="`编辑动画：`" style="width: 95%;">
        <el-button type="primary" @click="addAnimation()">
          添加
        </el-button>
        <el-button type="primary" @click="showProgrammeSimulation()">
          预览
        </el-button>
      </el-form-item>
      <el-table
        :data="sonAnimationData.animationData"
        class="animation-table"
        border
        style="width: 99%;"
      >
        <el-table-column :show-overflow-tooltip="true" label="分组名称">
          <template slot-scope="scope">
            {{ label[scope.row.operation] }}
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" label="操作类型">
          <template slot-scope="scope">
            {{ label[scope.row.operation] }} -
            {{ label[scope.row.operationType] }}
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="操作对象">
          <template slot-scope="scope">
            {{ presentText(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="opacity"
          :show-overflow-tooltip="true"
          label="开始时间"
        >
          <template slot-scope="scope">
            {{ scope.row.start.split(" ")[1] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="opacity"
          :show-overflow-tooltip="true"
          label="结束时间"
        >
          <template slot-scope="scope">
            {{ scope.row.end.split(" ")[1] }}
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <programmeSimulation
      v-if="programmeSimulationShow"
      title="动画"
      ref="programmeSimulation"
      :items="sonAnimationData.animationData"
      initCustomDate="1995-02-08 00:00:00"
      :maxTime="sonAnimationData.totalTime"
      :groups="groups"
      doubleSpeed="second"
      @shutDown="programmeSimulationShow = false"
      @animationNodes="animationNodes(arguments)"
    ></programmeSimulation>
    <animationAdd
      v-if="ifResourceOptions"
      :resourceOptions="resourceOptions"
      :sonAnimationData="sonAnimationData"
      @close="addAnimationClose"
      @submitUpdate="submitUpdate"
    ></animationAdd>
  </div>
</template>
<script>
import * as mapWork from "./map.js";
const programmeSimulation = () =>
  import("@/components/tables/Timeline/programmeSimulation.vue");
const animationAdd = () =>
  import("@/components/tables/program/screenplay/animation/Add.vue");
export default {
  name: "screenplay-animation",
  components: { programmeSimulation, animationAdd },
  props: ["animation", "resourceOptions"],
  model: {
    prop: "animation",
  },
  data() {
    return {
      sonAnimationData: this.animation,
      programmeSimulationShow: false,
      ifResourceOptions: false,
      groups: [{ id: 0, content: "", value: 0 }],
      label: {
        model: "模型",
        shp: "SHP",
        kml: "KML",
        plot: "标绘",
        map: "地图",
        // 操作
        show: "展示",
        opacity: "环境透明",
        flight: "视角飞行",
        overallStaining: "模型着色 / 透明",
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    animationNodes(data) {
      // console.log(...data, this.sonAnimationData.animationData);
      mapWork.processingData(...data, this.sonAnimationData.animationData);
    },
    addAnimation() {
      this.ifResourceOptions = true;
    },
    addAnimationClose() {
      this.ifResourceOptions = false;
    },
    submitUpdate(updateData) {
      //      id: 11,
      // group: 0,
      // content: "实际时间-2",
      updateData.id = this.sonAnimationData.animationData.length;
      updateData.group = 0; //为了在一行所以暂时为0
      // updateData.group = updateData.id;
      updateData.content = this.presentText(updateData);
      this.sonAnimationData.animationData.push(updateData);
      console.log(updateData);
    },
    presentText(item) {
      let { operation, presentText, opacity, flight } = item;
      let showPresentText;
      switch (operation) {
        case "opacity":
          showPresentText = `透明度：${opacity}`;
          break;
        case "flight":
          showPresentText = `${flight}`;
          break;
        case "overallStaining":
          showPresentText = `${presentText}`;
          break;

        default:
          showPresentText = presentText;
          break;
      }
      return showPresentText;
    },
    showProgrammeSimulation() {
      this.programmeSimulationShow = true;
    },
    init() {
      // let searchData = {
      //   projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
      // };
      // selectRoaming(searchData).then((res) => {
      //   let { code, data } = res.data;
      //   console.log(code, data.rows);
      //   this.options.ordinary = data.rows;
      // });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "sonAnimationData.type"(newData) {
      if (newData == 1) {
        this.sonAnimationData.company = "day";
      } else {
        this.sonAnimationData.company = "minute";
      }
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-date-editor .el-range-input {
  background: transparent;
  color: rgba(255, 255, 255, 0.9) !important;
  height: 36px !important;
}
/deep/ .el-date-editor .el-range-separator {
  color: rgba(255, 255, 255, 0.9) !important;
  line-height: 28px;
}
/deep/ .el-date-editor .el-range__icon {
  line-height: 28px;
}
.animation-mask:before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9;
}
/deep/ .el-date-editor {
  height: 36px;
  line-height: 36px;
}

.animation-table {
  /deep/.el-table__body-wrapper tbody tr {
    cursor: auto !important;
  }
}
</style>
